import type { UserAccount as GQLUserAccount } from '@/generated/graphql';
import * as TeamRole from '@/types/TeamRole';
import * as User from '@/types/User';

export interface UserAccount {
  id?: number;
  user?: User.User;
  teamRole?: TeamRole.TeamRole;
  teamRoleId?: number;
}

export const getNew = (): UserAccount => ({
  id: null,
  user: User.getNew(),
  teamRole: TeamRole.getNew(),
});

export const fromGql = (gqlUserAccount: GQLUserAccount): UserAccount => ({
  id: gqlUserAccount.id,
  teamRoleId: gqlUserAccount.teamRole?.id,
  teamRole: gqlUserAccount.teamRole ? TeamRole.fromGql(gqlUserAccount.teamRole) : TeamRole.getNew(),
  user: gqlUserAccount.user ? User.fromGql(gqlUserAccount.user) : User.getNew(),
});
